<template>
  <div class="navbar flex justify-between" :class="env">
    <div class="navbar-left flex">
      <div class="bold-links type-bold">
        <router-link v-for="link in boldLinks" :to="link.path" :key="link.name">
          <span>{{ link.name }}</span>
          <router-link v-if="link.subLink" :to="link.subLink.path">{{
            link.subLink.name
          }}</router-link>
          <div class="underline-effect"></div>
        </router-link>
      </div>
      <div class="normal-links type-standard">
        <router-link v-for="link in normalLinks" :to="link.path" :key="link.name">
          <span>{{ link.name }}</span>
          <div class="underline-effect"></div>
        </router-link>
      </div>
    </div>
    <div class="navbar-right">
      <div class="navbar-bu-switcher" v-if="businessUnitsWereFetched">
        <BusinessUnitSwitcherModal
          :selected-business-unit="selectedBusinessUnit"
          :available-business-units="availableBusinessUnits"
        />
      </div>
      <div class="navbar-logo flex items-center">
        <BriqIcon name="icon-logo-full" :customStyle="{ width: '63px', height: '33px' }" />
      </div>
    </div>
  </div>
</template>

<script>
import BusinessUnitSwitcherModal from '@v/topbar/BusinessUnitSwitcherModal.vue'
import { parseAxiosException } from '@/helpers/exceptionParser.js'

export default {
  name: 'BriqNavbar',
  components: { BusinessUnitSwitcherModal },
  props: {
    boldLinks: Array,
    normalLinks: Array,
  },
  data() {
    return {
      selectedBusinessUnit: null,
      availableBusinessUnits: [],
      businessUnitsWereFetched: false,
    }
  },
  computed: {
    env() {
      return this.$environment
    },
  },
  async mounted() {
    // todo: move this to store module
    try {
      const response = await this.$apiClient.get('business-unit/available')
      this.selectedBusinessUnit = response.data.selectedBusinessUnit
      this.availableBusinessUnits = response.data.availableBusinessUnits
      this.businessUnitsWereFetched = true
    } catch (e) {
      const parsedException = parseAxiosException(e)
      this.$logError(`Error expected to originate from ${parsedException.origin}`)
      this.$logError(parsedException.data)
      this.$notifyError('Something went wrong')
    }
  },
}
</script>

<style scoped lang="stylus">
.navbar-logo svg
  width 63px
  height 33px
</style>

<style scoped lang="stylus">
.navbar
  width 100%
  padding 20px 30px
  height 80px
  display flex
  font-family 'Roboto', sans-serif
  border-bottom 1px solid #ececec

  &.local
    background: lightgreen

  &.feature
    background: lightsteelblue

  &.test
    background: palegoldenrod

  &.staging
    background: lightpink

  .navbar-left
    .bold-links
      color black

    .normal-links
      color #2c333a

    .bold-links, .normal-links
      display flex
      align-items center

  .navbar-right
    display flex

    .business-unit-switcher
      text-align left

  a
    padding 8px 14px
    text-decoration none
    color #2c333a
    opacity 1
    position relative

    .underline-effect
      display block
      position absolute
      bottom 0
      left 0
      height 3px
      width 0
      background-color #2c333a
      transition width 0.3s ease

    // &:hover
    //   opacity 1

    //   .underline-effect
    //     width 100%

   .normal-links a
      opacity 0.6

      &:hover
        opacity 1

  .navbar-logo
    margin-left 15px
</style>
